<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout.vue'
import RobotSend from '@/components/notify/RobotSend.vue'

export default {
  name: 'DemoRobotSend',
  components: { RobotSend, PageHeaderLayout }
}

</script>

<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>
        <div class='theme-border default-padding' style='width: 900px;padding: 20px 30px'>
          <RobotSend  ref='refRobotSend'/>
        </div>

      </div>

    </PageHeaderLayout>

  </div>
</template>

<style scoped>

</style>
